import React from "react";
import styles from "./styles.module.scss";
import QRCode from "react-qr-code";

function QRCodePage() {
  return (
    <div className={styles.page}>
      <div className={styles.bodyContainer}>
        <div className={styles.title}>Welcome to Lilli</div>
        <p>
          Download the Lilli family app to start your kit setup. You can also
          use the app to invite a friend or relative to help with setup from
          their own phone.
        </p>

        <div className={styles.qrContainer}>
          <div className={styles.qrInnerContainer}>
            <a
              href={
                "https://play.google.com/store/apps/details?id=com.lilli_family_app"
              }
              className={styles.appStoreLink}
            >
              <img
                style={{ marginBottom: "16px" }}
                alt="android logo"
                src="/images/icons/android_logo.png"
                height={40}
              />
            </a>
            <div
              style={{
                marginBottom: "20px",
                marginRight: "20px",
                border: "1px solid #A5A5A5",
                borderRadius: "8px",
                padding: "10px",
                paddingBottom: "4px",
              }}
            >
              <QRCode
                value="https://play.google.com/store/apps/details?id=com.lilli_family_app"
                size={110}
              />
            </div>
          </div>
          <div className={styles.qrInnerContainer}>
            <a
              href={"https://apps.apple.com/ie/app/lilli-family/id6755149974"}
              className={styles.appStoreLink}
            >
              <img
                alt="apple logo"
                src="/images/icons/apple_logo.png"
                style={{ marginBottom: "16px" }}
                height={40}
              />
            </a>
            <div
              style={{
                marginBottom: "20px",
                marginRight: "20px",
                border: "1px solid #A5A5A5",
                borderRadius: "8px",
                padding: "10px",
                paddingBottom: "4px",
              }}
            >
              <QRCode
                value="https://apps.apple.com/ie/app/lilli-family/id6755149974"
                size={110}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default QRCodePage;
